import { Link } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';

export default function About() {
  usePageMeta({
    title: '关于我们',
    description: '了解漫画免费站品牌介绍、网站定位、发展理念、内容原则与用户口碑。漫画免费全集目录聚合平台，专注让每一位读者轻松找到想看的漫画。',
    keywords: '漫画免费,关于我们,漫画免费站,漫画免费全集聚合',
  });
  return (
    <main>
      <section className="relative flex min-h-[320px] items-center overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20artistic%20manga%20ink%20brush%20strokes%20with%20warm%20vermilion%20and%20amber%20gradient%2C%20books%20and%20paper%20texture%2C%20cozy%20reading%20atmosphere%2C%20stylized%20illustration%2C%20dark%20overlay%20for%20text%20readability&width=1600&height=700&seq=about-banner&orientation=landscape"
          alt="关于漫画免费站"
          title="漫画免费全集聚合平台介绍"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 text-center md:px-6">
          <h1 className="font-heading text-3xl text-background-50 md:text-4xl">关于漫画免费站</h1>
          <p className="mx-auto mt-3 max-w-xl text-background-100">漫画免费全集目录聚合平台，专注让每一位读者都能轻松找到想看的漫画。</p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <div className="grid gap-10 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl text-foreground-950">品牌介绍</h2>
              <p className="mt-4 leading-relaxed text-foreground-700">
                漫画免费站是一个专注漫画免费全集与全本目录聚合的阅读平台。我们持续整理热门长篇、完结佳作与各类漫画免费资源，按热血冒险、恋爱少女、玄幻奇幻等分类科学归档，让读者告别到处翻页的困扰，一站式找到想看的内容。
              </p>
              <h3 className="mt-6 font-heading text-xl text-foreground-900">网站定位</h3>
              <p className="mt-3 leading-relaxed text-foreground-700">
                面向广大漫画爱好者，提供「免费、聚合、清晰」的漫画全集目录导航。无论是追更长篇还是补番完结作品，都能在这里快速定位到对应分类与完整章节目录。
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-2xl text-foreground-950">发展理念</h2>
              <ul className="mt-4 space-y-4">
                {[
                  { icon: 'ri-leaf-line', title: '资源聚合', desc: '将分散的多部作品全集与全本目录聚合到一处，找书不再繁琐。' },
                  { icon: 'ri-price-tag-3-line', title: '免费阅读', desc: '坚持漫画免费阅读的初心，热门长篇与完结佳作均可免费查看。' },
                  { icon: 'ri-refresh-line', title: '持续更新', desc: '漫画免费资源每日整理，连载作品新章节第一时间同步目录。' },
                  { icon: 'ri-heart-3-line', title: '用户体验', desc: '以读者为中心，分类清晰、检索便捷，追更补番更省心。' },
                ].map((item) => (
                  <li key={item.title} className="flex gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                      <i className={item.icon} />
                    </span>
                    <div>
                      <h4 className="font-medium text-foreground-900">{item.title}</h4>
                      <p className="mt-1 text-sm text-foreground-600">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <h2 className="font-heading text-2xl text-foreground-950">内容原则</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { icon: 'ri-book-2-line', title: '内容精选', desc: '只收录有阅读价值的漫画作品，拒绝低质与重复内容，保证目录质量。' },
              { icon: 'ri-list-check-3', title: '目录清晰', desc: '每部作品均提供完整的全集目录与章节目录，全本资源整理有序。' },
              { icon: 'ri-eye-line', title: '尊重版权', desc: '坚持尊重作者与版权方，规范整理与展示相关内容资源。' },
            ].map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/15 text-accent-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <h2 className="font-heading text-2xl text-foreground-950">用户口碑</h2>
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {[
              { name: '漫游者小林', text: '分类很清晰，想找的热血长篇一次就翻到了，追更超省心。', tag: '热血漫画爱好者' },
              { name: '补番星人', text: '完结经典的全本资源整理得很全，一口气补完好多部经典作品。', tag: '完结补番党' },
              { name: '每天一漫', text: '每天更新都很及时，新章节同步快，页面干净看着舒服。', tag: '日更追番读者' },
            ].map((item) => (
              <figure key={item.name} className="rounded-lg border border-background-200 bg-background-100 p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {[...Array(5)].map((_, i) => <i key={i} className="ri-star-fill text-sm" />)}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">「{item.text}」</blockquote>
                <figcaption className="mt-4 flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-user-3-line" />
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>

          <div className="mt-10 rounded-lg bg-primary-700 p-6 text-center md:p-8">
            <h2 className="font-heading text-xl text-background-50 md:text-2xl">有任何建议或想看的漫画？</h2>
            <p className="mt-2 text-sm text-background-100">欢迎通过联系我们页面告诉我们，我们会尽快整理并更新到对应分类目录。</p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-accent-100"
            >
              联系我们 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}